import { rolePrivilegeStore } from '@shared/store/role-privilege.store';
import { RoleMap } from '@shared/types/components/role/role-guard.types';

export const hasRoleAccess = (privileges: RoleMap | RoleMap[]): boolean[] => {
  const { rolePrivileges } = rolePrivilegeStore.getState();

  // change the string to array here so we don't need to pass array for single privilege
  if (typeof privileges === 'string') privileges = [privileges];

  const defaultAccess = Array(privileges.length).fill(false);
  let access: boolean[] = defaultAccess;

  if (!rolePrivileges) return defaultAccess;

  access = privileges.reduce((acc: boolean[], curr) => {
    return [...acc, !!rolePrivileges[curr]];
  }, []);

  return access;
};
